import React from 'react';
import { TrendingUpIcon, SearchIcon, FilterIcon } from 'lucide-react';
export const AIRecommendations: React.FC = () => {
  return <div className="space-y-4" data-id="element-756">
      <div className="flex items-center justify-between mb-4" data-id="element-757">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-758">
          <TrendingUpIcon size={24} className="mr-2" data-id="element-759" />
          Rekomendasi AI (Upgrade & Versi Terbaru)
        </h1>
        <div className="flex space-x-2" data-id="element-760">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-761">
            Ekspor Rekomendasi
          </button>
          <button className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-762">
            Refresh Rekomendasi
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-763">
        <div className="p-4 border-b border-gray-200 flex flex-wrap gap-3 items-center justify-between" data-id="element-764">
          <div className="relative flex-grow max-w-md" data-id="element-765">
            <input type="text" placeholder="Cari rekomendasi..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-766" />
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-767" />
          </div>
          <div className="flex items-center gap-2" data-id="element-768">
            <button className="flex items-center px-3 py-2 bg-gray-100 rounded-md hover:bg-gray-200" data-id="element-769">
              <FilterIcon size={16} className="mr-1" data-id="element-770" />
              Filter
            </button>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-771">
              <option value="" data-id="element-772">Prioritas</option>
              <option value="high" data-id="element-773">Tinggi</option>
              <option value="medium" data-id="element-774">Menengah</option>
              <option value="low" data-id="element-775">Rendah</option>
            </select>
            <select className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-776">
              <option value="" data-id="element-777">Alasan</option>
              <option value="eol" data-id="element-778">EoL/EoS</option>
              <option value="performance" data-id="element-779">Kinerja</option>
              <option value="security" data-id="element-780">Keamanan</option>
              <option value="efficiency" data-id="element-781">Efisiensi</option>
            </select>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-782">
          <table className="w-full" data-id="element-783">
            <thead className="bg-neutral-light" data-id="element-784">
              <tr data-id="element-785">
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-786">
                  Aset
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-787">
                  Versi Sekarang
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-788">
                  Versi Rekomendasi
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-789">
                  Alasan
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-790">
                  Estimasi Biaya
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-791">
                  ROI/TCO 3 Tahun
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-792">
                  Prioritas
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-793">
                  Aksi
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-794">
              <tr className="hover:bg-neutral-light" data-id="element-795">
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-796">
                  Server Database Utama
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-797">
                  Dell PowerEdge R740 (2019)
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-798">
                  Dell PowerEdge R760 (2023)
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-799">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-800">
                    EoL/EoS 2024
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-801">
                  Rp 450.000.000
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-802">
                  <span className="text-accent-green" data-id="element-803">+15%</span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-804">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-805">
                    Tinggi
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-806">
                  <div className="flex space-x-1" data-id="element-807">
                    <button className="px-2 py-1 bg-accent-info text-white rounded-md text-xs" data-id="element-808">
                      Compare
                    </button>
                    <button className="px-2 py-1 bg-primary text-secondary rounded-md text-xs" data-id="element-809">
                      Ajukan
                    </button>
                  </div>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-810">
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-811">
                  Lisensi Oracle BINDA Jatim
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-812">
                  Oracle DB Standard 19c
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-813">
                  Oracle DB Standard 23c
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-814">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800" data-id="element-815">
                    Keamanan (CVE-2023-21555)
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-816">
                  Rp 325.000.000
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-817">
                  <span className="text-accent-green" data-id="element-818">+8%</span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-819">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800" data-id="element-820">
                    Menengah
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-821">
                  <div className="flex space-x-1" data-id="element-822">
                    <button className="px-2 py-1 bg-accent-info text-white rounded-md text-xs" data-id="element-823">
                      Compare
                    </button>
                    <button className="px-2 py-1 bg-primary text-secondary rounded-md text-xs" data-id="element-824">
                      Ajukan
                    </button>
                  </div>
                </td>
              </tr>
              <tr className="hover:bg-neutral-light" data-id="element-825">
                <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-826">
                  Router Backbone STIN
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-827">
                  Cisco Catalyst 9500 (IOS XE 17.3)
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-828">
                  Cisco Catalyst 9500 (IOS XE 17.9)
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-829">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-830">
                    Kinerja & Fitur Baru
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-831">
                  Rp 0 (Upgrade Firmware)
                </td>
                <td className="px-4 py-3 text-sm text-gray-700" data-id="element-832">
                  <span className="text-accent-green" data-id="element-833">+5%</span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-834">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-835">
                    Rendah
                  </span>
                </td>
                <td className="px-4 py-3 text-sm" data-id="element-836">
                  <div className="flex space-x-1" data-id="element-837">
                    <button className="px-2 py-1 bg-accent-info text-white rounded-md text-xs" data-id="element-838">
                      Compare
                    </button>
                    <button className="px-2 py-1 bg-primary text-secondary rounded-md text-xs" data-id="element-839">
                      Ajukan
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-840">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-841">
          <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-842">
            <h2 className="font-bold text-secondary" data-id="element-843">
              Compare View: Server Database Utama
            </h2>
          </div>
          <div className="p-4" data-id="element-844">
            <div className="grid grid-cols-2 gap-4" data-id="element-845">
              <div className="bg-neutral-light p-3 rounded-lg" data-id="element-846">
                <div className="mb-3" data-id="element-847">
                  <h3 className="font-medium text-secondary" data-id="element-848">Versi Sekarang</h3>
                  <p className="text-sm text-gray-700" data-id="element-849">
                    Dell PowerEdge R740 (2019)
                  </p>
                </div>
                <div className="space-y-2" data-id="element-850">
                  <div data-id="element-851">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-852">
                      SPESIFIKASI
                    </h4>
                    <p className="text-sm" data-id="element-853">
                      2x Intel Xeon Gold 5218, 64GB RAM, 4TB SSD
                    </p>
                  </div>
                  <div data-id="element-854">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-855">
                      PERFORMA
                    </h4>
                    <p className="text-sm" data-id="element-856">Baseline</p>
                  </div>
                  <div data-id="element-857">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-858">
                      KEAMANAN
                    </h4>
                    <p className="text-sm text-accent-red" data-id="element-859">
                      3 CVE kritikal belum dipatch
                    </p>
                  </div>
                  <div data-id="element-860">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-861">
                      DUKUNGAN
                    </h4>
                    <p className="text-sm text-accent-red" data-id="element-862">Berakhir 2024</p>
                  </div>
                </div>
              </div>
              <div className="bg-green-50 p-3 rounded-lg" data-id="element-863">
                <div className="mb-3" data-id="element-864">
                  <h3 className="font-medium text-secondary" data-id="element-865">
                    Versi Rekomendasi
                  </h3>
                  <p className="text-sm text-gray-700" data-id="element-866">
                    Dell PowerEdge R760 (2023)
                  </p>
                </div>
                <div className="space-y-2" data-id="element-867">
                  <div data-id="element-868">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-869">
                      SPESIFIKASI
                    </h4>
                    <p className="text-sm" data-id="element-870">
                      2x Intel Xeon Gold 6430, 128GB RAM, 8TB NVMe
                    </p>
                  </div>
                  <div data-id="element-871">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-872">
                      PERFORMA
                    </h4>
                    <p className="text-sm text-accent-green" data-id="element-873">
                      +75% peningkatan throughput
                    </p>
                  </div>
                  <div data-id="element-874">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-875">
                      KEAMANAN
                    </h4>
                    <p className="text-sm text-accent-green" data-id="element-876">
                      Mitigasi CVE terbaru
                    </p>
                  </div>
                  <div data-id="element-877">
                    <h4 className="text-xs font-medium text-gray-500" data-id="element-878">
                      DUKUNGAN
                    </h4>
                    <p className="text-sm text-accent-green" data-id="element-879">Hingga 2030</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 p-3 bg-blue-50 rounded-lg" data-id="element-880">
              <h3 className="font-medium text-secondary mb-2" data-id="element-881">
                Analisis ROI & TCO (3 Tahun)
              </h3>
              <div className="space-y-2" data-id="element-882">
                <div className="flex justify-between" data-id="element-883">
                  <span className="text-sm" data-id="element-884">Biaya Investasi Awal:</span>
                  <span className="text-sm font-medium" data-id="element-885">Rp 450.000.000</span>
                </div>
                <div className="flex justify-between" data-id="element-886">
                  <span className="text-sm" data-id="element-887">Penghematan Operasional:</span>
                  <span className="text-sm font-medium text-accent-green" data-id="element-888">
                    Rp 120.000.000
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-889">
                  <span className="text-sm" data-id="element-890">Penghematan Energi:</span>
                  <span className="text-sm font-medium text-accent-green" data-id="element-891">
                    Rp 85.000.000
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-892">
                  <span className="text-sm" data-id="element-893">Peningkatan Produktivitas:</span>
                  <span className="text-sm font-medium text-accent-green" data-id="element-894">
                    Rp 250.000.000
                  </span>
                </div>
                <div className="pt-2 border-t border-blue-200 flex justify-between" data-id="element-895">
                  <span className="text-sm font-medium" data-id="element-896">
                    Total ROI (3 Tahun):
                  </span>
                  <span className="text-sm font-medium text-accent-green" data-id="element-897">
                    +15%
                  </span>
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-4 space-x-2" data-id="element-898">
              <button className="px-3 py-1.5 border border-gray-300 rounded text-sm" data-id="element-899">
                Tunda
              </button>
              <button className="px-3 py-1.5 bg-accent-info text-white rounded text-sm" data-id="element-900">
                Masuk RKA
              </button>
              <button className="px-3 py-1.5 bg-primary text-secondary rounded text-sm" data-id="element-901">
                Ajukan Upgrade
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-902">
          <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center justify-between" data-id="element-903">
            <h2 className="font-bold text-secondary" data-id="element-904">
              End-of-Life & End-of-Support Alert
            </h2>
            <span className="text-xs bg-accent-red text-white px-2 py-1 rounded" data-id="element-905">
              Perhatian Segera
            </span>
          </div>
          <div className="p-4" data-id="element-906">
            <div className="border-l-4 border-accent-red p-4 bg-red-50 rounded-r-lg mb-4" data-id="element-907">
              <h3 className="font-medium text-secondary mb-1" data-id="element-908">
                Aset Kritis Mendekati EOL/EOS
              </h3>
              <p className="text-sm text-gray-700 mb-3" data-id="element-909">
                Beberapa aset kritis akan mencapai End-of-Life atau
                End-of-Support dalam 12 bulan ke depan. Tindakan segera
                diperlukan untuk menghindari risiko keamanan dan operasional.
              </p>
            </div>
            <div className="space-y-3" data-id="element-910">
              <div className="bg-neutral-light p-3 rounded-lg" data-id="element-911">
                <div className="flex justify-between items-start" data-id="element-912">
                  <div data-id="element-913">
                    <h3 className="font-medium text-secondary" data-id="element-914">
                      Server Database Utama
                    </h3>
                    <p className="text-xs text-gray-600" data-id="element-915">Dell PowerEdge R740</p>
                  </div>
                  <span className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-916">
                    EOL: Agustus 2024
                  </span>
                </div>
                <div className="mt-2 space-y-1" data-id="element-917">
                  <p className="text-xs text-gray-700" data-id="element-918">
                    <span className="font-medium" data-id="element-919">Risiko:</span> Tidak ada patch
                    keamanan, dukungan vendor terbatas
                  </p>
                  <p className="text-xs text-gray-700" data-id="element-920">
                    <span className="font-medium" data-id="element-921">Dampak:</span> Tinggi (sistem
                    kritis nasional)
                  </p>
                </div>
                <div className="mt-2 flex justify-end" data-id="element-922">
                  <button className="px-2 py-1 bg-accent-info text-white rounded text-xs" data-id="element-923">
                    Lihat Rekomendasi
                  </button>
                </div>
              </div>
              <div className="bg-neutral-light p-3 rounded-lg" data-id="element-924">
                <div className="flex justify-between items-start" data-id="element-925">
                  <div data-id="element-926">
                    <h3 className="font-medium text-secondary" data-id="element-927">
                      Windows Server 2016
                    </h3>
                    <p className="text-xs text-gray-600" data-id="element-928">
                      Multiple Servers (15)
                    </p>
                  </div>
                  <span className="text-xs bg-orange-100 text-orange-800 px-2 py-0.5 rounded-full" data-id="element-929">
                    EOS: Januari 2025
                  </span>
                </div>
                <div className="mt-2 space-y-1" data-id="element-930">
                  <p className="text-xs text-gray-700" data-id="element-931">
                    <span className="font-medium" data-id="element-932">Risiko:</span> Kerentanan
                    keamanan tidak dipatch
                  </p>
                  <p className="text-xs text-gray-700" data-id="element-933">
                    <span className="font-medium" data-id="element-934">Dampak:</span> Menengah
                    (sistem internal)
                  </p>
                </div>
                <div className="mt-2 flex justify-end" data-id="element-935">
                  <button className="px-2 py-1 bg-accent-info text-white rounded text-xs" data-id="element-936">
                    Lihat Rekomendasi
                  </button>
                </div>
              </div>
              <div className="bg-neutral-light p-3 rounded-lg" data-id="element-937">
                <div className="flex justify-between items-start" data-id="element-938">
                  <div data-id="element-939">
                    <h3 className="font-medium text-secondary" data-id="element-940">
                      Cisco ASA 5500-X
                    </h3>
                    <p className="text-xs text-gray-600" data-id="element-941">
                      BINDA Sumatera Barat
                    </p>
                  </div>
                  <span className="text-xs bg-red-100 text-red-800 px-2 py-0.5 rounded-full" data-id="element-942">
                    EOL: Desember 2023
                  </span>
                </div>
                <div className="mt-2 space-y-1" data-id="element-943">
                  <p className="text-xs text-gray-700" data-id="element-944">
                    <span className="font-medium" data-id="element-945">Risiko:</span> Kerentanan
                    firewall, tidak ada update
                  </p>
                  <p className="text-xs text-gray-700" data-id="element-946">
                    <span className="font-medium" data-id="element-947">Dampak:</span> Tinggi
                    (keamanan perimeter)
                  </p>
                </div>
                <div className="mt-2 flex justify-end" data-id="element-948">
                  <button className="px-2 py-1 bg-accent-info text-white rounded text-xs" data-id="element-949">
                    Lihat Rekomendasi
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-4 flex justify-end" data-id="element-950">
              <button className="bg-accent-red text-white px-3 py-1.5 rounded text-sm" data-id="element-951">
                Buat Rencana Mitigasi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};